import Student from "../components/ads/SearchStudent";
import SEO from "../components/SEO";

function Search() {
  return (
    <div className="page p-1">
      <SEO
        title="Search Students — Tutoring Platform"
        description="Browse student requests and connect with learners looking for tutors."
        image="/logo192.png"
      />
      <Student />
    </div>
  );
}

export default Search;
